import PropTypes from 'prop-types';
import React from 'react';
import { Button, Form } from '@weezevent/nacre';
import Inventory from '../../models/inventory';
import { useTranslation } from 'react-i18next';
import InventoriesPicker from '../../components/charts/inventoriesPicker';
import CardLoader from '../../components/cardLoader';

export default function PartnerBatchBookingsInventories({ onChange, onCardDone, partnerId, organizationId, inventories }) {
    const [loading, setLoading] = React.useState(true);
    let [fetchedInventories, setNewInventory] = React.useState([]);

    const { t } = useTranslation();

    React.useEffect(() => {
        Inventory.getAll({ organizationId, partnerId }).then(response => {
            setNewInventory(response);
        });
        setLoading(false);
    }, [organizationId, partnerId]);

    const onSetInventories = React.useCallback(selected => {
        onChange(selected);
    }, []);

    if (loading) {
        return <CardLoader />;
    }

    return (
        <>
            <Form.Field>
                <Form.Label label={t('ticket.partners.batch.event.label')} />
                {!loading && (
                    <InventoriesPicker
                        onSave={onSetInventories}
                        organizationId={organizationId}
                        activeInventories={fetchedInventories.filter(inventory => ['published', 'draft'].includes(inventory?.event?.publication_status))}
                        currentSelected={inventories}
                    />
                )}
            </Form.Field>
            <Button primary label={t('ticket.common.action.continue')} className={'partner-continue-button'} onClick={onCardDone} disabled={!inventories.length} />
        </>
    );
}

PartnerBatchBookingsInventories.propTypes = {
    onCardDone: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    inventories: PropTypes.array.isRequired,
    partnerId: PropTypes.string.isRequired,
    organizationId: PropTypes.number.isRequired
};
